import Other from "@/layout/other.vue";
import MyCenterMenu from "@/layout/my-menu.vue";

import Home from "@/layout/home.vue"; 
import MyCenterMenu2 from "@/layout/my-menu2.vue";

const routes = [
  // {
  //   path: "/",
  //   name: "index",
  //   component: Other,
  //   redirect: "/main",
  //   children: [
  //     {
  //       path: "/main",
  //       name: "Main",
  //       component: () => import("@/views/main/index.vue"),
  //       meta: {
  //         title: "首页",
  //       },
  //     },
  //   ],
  // },
  {
    path: "/",
    name: "MyCenter",
    component: MyCenterMenu,
    redirect: "/myCenter/courseList",
    children: [
      {
        path: "/myCenter/courseList",
        name: "CourseList",
        component: () => import("@/views/my-center/course-list.vue"),
        meta: {
          title: "我的课程",
        },
      },
      {
        path: "/myCenter/liveList",
        name: "LiveList",
        component: () => import("@/views/my-center/live-list.vue"),
        meta: {
          title: "我的直播",
        },
      },
      {
        path: "/myCenter/ask",
        name: "Ask",
        component: () => import("@/views/my-center/ask.vue"),
        meta: {
          title: "我的提问",
        },
      },
      {
        path: "/myCenter/error",
        name: "Error",
        component: () => import("@/views/my-center/error.vue"),
        meta: {
          title: "我的错题",
        },
      },
      {
        path: "/myCenter/progress",
        name: "MyProgress",
        component: () => import("@/views/my-center/progress.vue"),
        meta: {
          title: "学习进度",
        },
      },
      {
        path: "/myCenter/schoolRoll",
        name: "SchoolRoll",
        component: () => import("@/views/my-center/school-roll.vue"),
        meta: {
          title: "学籍信息",
        },
      },
      {
        path: "/myCenter/testManage",
        name: "TestManage",
        component: () => import("@/views/my-center/test-manage.vue"),
        meta: {
          title: "考试管理",
        },
      },
      {
        path: "/myCenter/paperManage",
        name: "PaperManage",
        component: () => import("@/views/my-center/paper-manage.vue"),
        meta: {
          title: "论文管理",
        },
      },
      {
        path: "/myCenter/graduateApply",
        name: "GraduateApply",
        component: () => import("@/views/my-center/graduate-apply.vue"),
        meta: {
          title: "毕业申请",
        },
      },
      {
        path: "/myCenter/degreeApply",
        name: "DegreeApply",
        component: () => import("@/views/my-center/degree-apply.vue"),
        meta: {
          title: "学位申请",
        },
      },
      {
        path: "/myCenter/myAgreement",
        name: "MyAgreement",
        component: () => import("@/views/my-center/my-agreement.vue"),
        meta: {
          title: "我的协议",
        },
      },
      {
        path: "/myCenter/paymentOrder",
        name: "PaymentOrder",
        component: () => import("@/views/my-center/payment-order.vue"),
        meta: {
          title: "缴费订单",
        },
      },
      {
        path: "/myCenter/notification",
        name: "Notification",
        component: () => import("@/views/my-center/notification.vue"),
        meta: {
          title: "消息通知",
        },
      },
      {
        path: "/myCenter/setUp",
        name: "SetUp",
        component: () => import("@/views/my-center/set-up.vue"),
        meta: {
          title: "设置",
        },
      },
    ],
  },
  {
    path: "/course",
    name: "Course",
    component: Other,
    redirect: "/course",
    children: [
      {
        path: "/course",
        name: "Course",
        component: () => import("@/views/course/index.vue"),
        meta: {
          title: "课程中心",
        },
      },
    ],
  },
  {
    path: "/learn",
    name: "Learn",
    component: Other,
    redirect: "/course/videoLearning",
    children: [
      {
        path: "/course/videoLearning",
        name: "VideoLearning",
        component: () => import("@/views/course/video-learning.vue"),
        meta: {
          title: "录播课学习包",
        },
      },
      {
        path: "/course/chapterExercise",
        name: "ChapterExercise",
        component: () => import("@/views/exercise/chapter.vue"),
        meta: {
          title: "章节练习",
        },
      },
      {
        path: "/course/testExercise",
        name: "TestExercise",
        component: () => import("@/views/exercise/test.vue"),
        meta: {
          title: "模拟试卷",
        },
      },
      {
        path: "/course/live",
        name: "Live",
        component: () => import("@/views/live/detail.vue"),
        meta: {
          title: "观看直播",
        },
      },
      {
        path: "/course/error",
        name: "ChapterError",
        component: () => import("@/views/exercise/error.vue"),
        meta: {
          title: "错题本",
        },
      },
    ],
  },
  {
    name: "Validation",
    path: "/validation",
    component: Other,
    redirect: "ValidationAgree",
    meta: {
      title: "验证",
    },
    children: [
      {
        path: "/validation/agree",
        name: "ValidationAgree",
        component: () => import("@/views/validation/index.vue"),
        meta: {
          title: "验证",
        },
      },
    ],
  },
  {
    name: "MyCenterContent",
    path: "/myCenterContent",
    component: Other,
    redirect: "My",
    meta: {
      title: "个人中心",
    },
    children: [
      {
        path: "/myCenterContent/paperApply",
        name: "MyPaper",
        component: () => import("@/views/my-center-content/paper/index.vue"),
        meta: {
          title: "论文管理",
        },
      },
      {
        path: "/myCenterContent/graduateApply",
        name: "MyGraduateApply",
        component: () =>
          import("@/views/my-center-content/graduate-apply/index.vue"),
        meta: {
          title: "毕业申请",
        },
      },
      {
        path: "/myCenterContent/degreeApply",
        name: "MyDegreeApply",
        component: () =>
          import("@/views/my-center-content/degree-apply/index.vue"),
        meta: {
          title: "学位申请",
        },
      },
    ],
  },

  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login"),
    meta: {
      title: "登录",
    },
  },

  // ==========================================================================  
  {
    path: "/home",
    name: "home", 
    component: Home,
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/home/index.vue"),
        meta: {
          title: "首页",
        },
      },
      {
        path: "/home/notice",
        name: "homeNotice",
        component: () => import("@/views/home/notice/index.vue"),
        meta: {
          title: "公告",
        },
      },
      {
        path: "/home/notice/details",
        name: "homeNoticeDetails",
        component: () => import("@/views/home/notice/details.vue"),
        meta: {
          title: "公告详情",
        },
      },
    ],
  },
  {
    path: "/notice/details",
    name: "noticeDetail",
    component: () => import("@/views/my_page/notice/details.vue"),
    meta: {
      title: "公告详情",
    },
  }, 
  // 个人中心 
  {
    path: "/myPage",
    name: "myPage",
    component: MyCenterMenu2,
    redirect: "/myPage/practical",
    children: [
      {
        path: "/myPage/practical",
        name: "practical",
        component: () => import("@/views/my_page/practical/index.vue"),
        meta: {
          title: "实践考试", 
        },
      },
      {
        path: "/myPage/practiceTraining",
        name: "practiceTraining",
        component: () => import("@/views/my_page/practice_training/index.vue"),
        meta: {
          title: "实践培训",
        },
      },
      {
        path: "/myPage/thesis",
        name: "thesis",
        component: () => import("@/views/my_page/thesis/index.vue"),
        meta: {
          title: "毕业论文",
        },
      },
      {
        path: "/myPage/dissertation",
        name: "dissertation",
        component: () => import("@/views/my_page/dissertation/index.vue"),
        meta: {
          title: "学位论文",
        },
      },
      {
        path: "/myPage/studentStatus",
        name: "studentStatus",
        component: () => import("@/views/my_page/student_status/index.vue"),
        meta: {
          title: "我的学籍",
        },
      },
      {
        path: "/myPage/notice",
        name: "notice",
        component: () => import("@/views/my_page/notice/index.vue"),
        meta: {
          title: "通知公告",
        },
      },
    ]
  }
  // ------------------------------




];

export default routes;
